import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { AnimatePresence, easeInOut, motion } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
type InnerTableProps = {
  title: string;
  badge?: BadgeProps;
  children: React.ReactNode;
};
type BadgeProps = {
  variant: 'success' | 'error' | 'neutral';
  label: string;
};
const Badge = t0 => {
  const $ = _c(8);
  const {
    variant,
    label
  } = t0;
  const t1 = `size-1.5 rounded-full ${variant === "success" ? "bg-[var(--text-color-success)] outline-2 outline-[var(--text-color-success-inverted)]" : "bg-[var(--text-color-error)] outline outline-error"}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `text-body-2 ${variant === "success" ? "text-success" : "text-error"}`;
  let t4;
  if ($[2] !== label || $[3] !== t3) {
    t4 = <p className={t3}>{label}</p>;
    $[2] = label;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className="flex items-center gap-2">{t2}{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
const InnerTable = t0 => {
  const $ = _c(29);
  const {
    title,
    badge,
    children
  } = t0;
  const [showMore, setShowMore] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.financial"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== showMore) {
    t2 = cx("flex items-center justify-between gap-2 px-3 py-2 text-body-2", {
      "border-b-none text-tertiary": !showMore
    }, {
      "border-b border-dashed border-tertiary text-primary": showMore
    });
    $[1] = showMore;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== badge) {
    t3 = badge && <Badge variant={badge.variant} label={badge.label} />;
    $[3] = badge;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-label-2 text-tertiary">⋅</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== showMore) {
    t5 = () => setShowMore(!showMore);
    $[6] = showMore;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== showMore || $[9] !== t) {
    t6 = showMore ? t(_temp) : t(_temp2);
    $[8] = showMore;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="min-w-[74px] flex items-center justify-center"><LinkButton variant="label-2" onClick={t5}>{t6}</LinkButton></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t7) {
    t8 = <div className="flex items-center gap-2">{t3}{t4}{t7}</div>;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8 || $[19] !== title) {
    t9 = <div className={t2}>{title}{t8}</div>;
    $[17] = t2;
    $[18] = t8;
    $[19] = title;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== children || $[22] !== showMore) {
    t10 = showMore && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: easeInOut
    }} style={{
      overflow: "hidden"
    }}><div className="flex flex-col gap-3 p-3">{children}</div></motion.div>;
    $[21] = children;
    $[22] = showMore;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10) {
    t11 = <AnimatePresence>{t10}</AnimatePresence>;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <div className="flex flex-col border rounded-md border-tertiary">{t9}{t11}</div>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default InnerTable;
function _temp($) {
  return $.showLess;
}
function _temp2($_0) {
  return $_0.showMore;
}